export const CARD_TURNOVER = 'card_turn_over';
export const AVERAGE_CARD_PAYMENT = 'average_card_payment';
export const INDUSTRY = 'industry';
export const SECTOR = 'sector';
export const PAYMENT_CHANNEL = 'paymentChannel';
export const FACE_TO_FACE_PERCENTAGE = 'faceToFacePercentage';
export const MANAGE_PCI_DSS = 'pciDss';
